import { FC, MouseEvent, ReactElement, ReactNode } from 'react';

import { Flex, StyleProps, Text } from '@bonusly/design-system';

import { CountBadge } from '../../../../components/badge/count-badge';
import { ColorScheme, IconChip } from '../Chip';
import { DropdownOption } from '../Dropdown';
import { SmartLink } from '../SmartLink/SmartLink';

interface Props extends StyleProps {
	badgeCount?: number;
	children: ReactNode;
	colorScheme?: ColorScheme;
	icon: ReactElement;
	onClick?: (e: MouseEvent) => void;
	to?: string;
	p?: number;
	textML?: number;
}

export const NavMenuItem: FC<Props> = ({ badgeCount, children, colorScheme, icon, onClick, to, p = 2, textML = 3, ...rest }) => {
	const Component = to ? SmartLink : 'button';
	const linkProps = to ? { to } : {};

	return (
		<DropdownOption p={p} variant="floating" {...rest}>
			<Flex as={Component} width="100%" data-testid="nav-menu-item" onClick={onClick} alignItems="center" {...linkProps}>
				<CountBadge count={badgeCount}>
					<IconChip colorScheme={colorScheme}>{icon}</IconChip>
				</CountBadge>

				<Text as="span" color="gray.700" ml={textML} fontSize="md" fontWeight="medium">
					{children}
				</Text>
			</Flex>
		</DropdownOption>
	);
};
